module.exports = __webpack_public_path__ + "static/media/guide_img1_3_m.01df7c9c.png";